import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaLaptop, FaEdit, FaShoppingCart, FaEnvelope, FaMapMarkedAlt, FaCreditCard, FaImage, FaPencilAlt } from 'react-icons/fa';

// --- Styled Components ---
const CotizadorContainer = styled.div`
  max-width: 900px;
  margin: 40px auto;
  padding: 30px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
`;

const SectionTitle = styled.h2`
  color: #333;
  margin-top: 40px;
  margin-bottom: 20px;
  text-align: center;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25px;
  border: 2px solid ${props => props.isSelected ? '#007bff' : '#ddd'};
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${props => props.isSelected ? '#e9f5ff' : '#fafafa'};

  &:hover {
    border-color: #007bff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .card-icon {
    font-size: 48px;
    color: ${props => props.isSelected ? '#007bff' : '#666'};
    margin-bottom: 15px;
  }

  h4 {
    margin: 0;
    color: #444;
  }

  p {
    color: #777;
    font-size: 14px;
    margin: 10px 0;
  }

  span {
    font-size: 24px;
    font-weight: bold;
    color: #007bff;
  }
`;

const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
`;

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  background-color: #fafafa;
  padding: 15px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid ${props => props.isChecked ? '#28a745' : '#ddd'};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.isChecked ? '#eafff1' : '#f0f0f0'};
  }

  input[type="checkbox"] {
    display: none;
  }

  .checkbox-icon {
    font-size: 24px;
    color: ${props => props.isChecked ? '#28a745' : '#777'};
    margin-right: 15px;
  }

  .checkbox-details {
    flex-grow: 1;
  }

  .checkbox-title {
    font-weight: bold;
    color: #444;
  }

  .checkbox-price {
    color: #28a745;
    font-weight: bold;
  }

  .checkbox-description {
    color: #777;
    font-size: 12px;
  }
`;

const TotalContainer = styled.div`
  background-color: #f8f9fa;
  border: 2px dashed #ccc;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  margin-top: 40px;

  h3 {
    margin: 0;
    color: #555;
  }

  span {
    font-size: 36px;
    font-weight: bold;
    color: #007bff;
    margin-top: 10px;
    display: block;
  }
`;

// --- Datos y Lógica del Componente ---
const precios = {
 
   MiniPage: {
    nombre: 'Pagina web Informativa',
    precio: 175000,
    descripcion: 'Página web inicial simple para dar a conocer tu emprendimiento o servicios. Incluye una pagina,hasta 25 imagenes. Responsive(adaptable a celular, tablet o pc), Enlaces a redes sociales,WhatsApp flotante, Hosting gratis el primer año. Dominio gratis el primer año. Unico pago, Sin cuota mensual',
    icon: <FaLaptop className="card-icon" />
  },
  autogestionable: {
    nombre: 'Página Autogestionable',
    precio: 430000,
    descripcion: 'Incluye todo lo de la Landig Page mas un sistema CMS para que puedas editar y subir propio tu contenido.',
    icon: <FaEdit className="card-icon" />
  },
   landingPage: {
    nombre: 'Landing Page',
    precio: 225000,
    descripcion: 'Página web de presentación simple y estática, para dar a conocer tu emprendimiento.Incluye una pagina de hasta 5 secciones, Responsive(adaptable a celular, tablet o pc), Enlaces a redes sociales,WhatsApp flotante, Hosting gratis el primer año.SSL gratis el primer año.Dominio gratis el primer año.Alta en buscadores.Unico pago, Sin cuota mensual',
    icon: <FaLaptop className="card-icon" />
  },
  ecommerce: {
    nombre: 'E-commerce o Tienda online',
    precio: 470000,
    descripcion: 'Incluye todo lo de la Landing Page y de web autogestionable, mas una Tienda en línea completa con carrito de compras y gestión de productos.',
    icon: <FaShoppingCart className="card-icon" />
  },
  componentes: {
    formularioContacto: {
      nombre: 'Formulario de Contacto',
      precio: 50000,
      descripcion: 'Para recibir mensajes de tus visitantes.',
      icon: <FaEnvelope className="checkbox-icon" />
    },
    mapaInteractivo: {
      nombre: 'Mapa Interactivo',
      precio: 75000,
      descripcion: 'Muestra tu ubicación en un mapa de Google.',
      icon: <FaMapMarkedAlt className="checkbox-icon" />
    },
    carritoCompra: {
      nombre: 'Carrito de Compra',
      precio: 250000,
      descripcion: 'Permite a los usuarios guardar productos (requiere E-commerce).',
      icon: <FaShoppingCart className="checkbox-icon" />
    },
    pasarelaPago: {
      nombre: 'Pasarela de Pago',
      precio: 250000,
      descripcion: 'Procesamiento de pagos online (Mercado Pago, Tarjetas, etc.).',
      icon: <FaCreditCard className="checkbox-icon" />
    },
    galeriaImagenes: {
      nombre: 'Galería de Imágenes',
      precio: 100000,
      descripcion: 'Para mostrar mas de 25 fotos o videos en tu web o portafolio.',
      icon: <FaImage className="checkbox-icon" />
    },
    blog: {
      nombre: 'Blog',
      precio: 150000,
      descripcion: 'Sección para publicar artículos y noticias.',
      icon: <FaPencilAlt className="checkbox-icon" />
    }
  }
};

const Cotizador = () => {
  const [tipoPagina, setTipoPagina] = useState(null);
  const [componentesSeleccionados, setComponentesSeleccionados] = useState([]);
  const [precioTotal, setPrecioTotal] = useState(0);

  // Calcula el precio total cada vez que cambian las selecciones
  useEffect(() => {
    let subtotal = 0;
    if (tipoPagina) {
      subtotal += precios[tipoPagina].precio;
    }
    componentesSeleccionados.forEach(comp => {
      subtotal += precios.componentes[comp].precio;
    });
    setPrecioTotal(subtotal);
  }, [tipoPagina, componentesSeleccionados]);

  // Maneja la selección del tipo de página (solo una opción)
  const handleSelectTipo = (tipo) => {
    setTipoPagina(tipo);
    // Reinicia los componentes si cambia de tipo de página principal
    // Para evitar que se mantengan opciones de e-commerce en una landing, por ejemplo
    setComponentesSeleccionados([]);
  };

  // Maneja la selección de componentes adicionales
  const handleSelectComponente = (componente) => {
    setComponentesSeleccionados(prev => {
      if (prev.includes(componente)) {
        return prev.filter(item => item !== componente);
      } else {
        return [...prev, componente];
      }
    });
  };

  return (
    <CotizadorContainer>
      <SectionTitle>Tu pagina web personalizada</SectionTitle>
      <CardGrid>
        {Object.entries(precios).slice(0, 4).map(([key, value]) => (
          <Card 
            key={key} 
            onClick={() => handleSelectTipo(key)} 
            isSelected={tipoPagina === key}
          >
            {value.icon}
            <h4>{value.nombre}</h4>
            <p>{value.descripcion}</p>
            <span>${value.precio.toLocaleString()}</span>
          </Card>
        ))}
      </CardGrid>

      {tipoPagina && (
        <>
          <SectionTitle>Agrega componentes adicionales</SectionTitle>
          <CheckboxGrid>
            {Object.entries(precios.componentes).map(([key, value]) => (
              <CheckboxContainer 
                key={key} 
                isChecked={componentesSeleccionados.includes(key)}
              >
                <input 
                  type="checkbox" 
                  checked={componentesSeleccionados.includes(key)} 
                  onChange={() => handleSelectComponente(key)} 
                />
                {value.icon}
                <div className="checkbox-details">
                  <div className="checkbox-title">{value.nombre}</div>
                  <div className="checkbox-price">+${value.precio.toLocaleString()}</div>
                  <div className="checkbox-description">{value.descripcion}</div>
                </div>
              </CheckboxContainer>
            ))}
          </CheckboxGrid>
        </>
      )}

      <TotalContainer>
        <h3>Precio Total Estimado</h3>
        <span>${precioTotal.toLocaleString()}</span>
      </TotalContainer>
    </CotizadorContainer>
  );
};

export default Cotizador;